import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default FadeIn;
